"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class SitePermission extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'sitePermission';
        this._siteId = initParams.site_id;
        this._orgId = initParams.org_id;
        this._orgName = initParams.org_name;
        this._permName = initParams.perm_name;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateSitePermission(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set orgId(value) {
        console.error('Do not set objects this way');
    }
    setOrgId(value) {
        return this.dataService.updateSitePermission(this.id, { org_id: value }, this);
    }
    get orgId() {
        return this._orgId;
    }
    set orgName(value) {
        console.error('Do not set objects this way');
    }
    setOrgName(value) {
        return this.dataService.updateSitePermission(this.id, { org_name: value }, this);
    }
    get orgName() {
        return this._orgName;
    }
    set permName(value) {
        console.error('Do not set objects this way');
    }
    setPermName(value) {
        return this.dataService.updateSitePermission(this.id, { perm_name: value }, this);
    }
    get permName() {
        return this._permName;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateSitePermission(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteSitePermission(this.id, this);
    }
}
exports.default = SitePermission;
//# sourceMappingURL=sitePermission.js.map